export function formattedTranslationValue(translations, valueKey, locale) {
	if (!translations || !valueKey) return "";
	const isExist = translations.some((tl) => tl.hasOwnProperty(valueKey));
	if (!isExist || !locale) return "";

	const translation =
		translations.find((t) => t.language.code === locale)?.[valueKey] ?? "";
	return translation;
}
